<template>
    <div class="w-full">
        <h3 class="text-slate-800 text-lg font-medium mb-3">Hotels</h3>
        <div class="p-2 bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50">
            <div class="grid grid-cols-6 gap-4 min-h-72 bg-slate-50 rounded">
                <div
                    class="col-span-6 md:col-span-3 flex items-center pr-8 py-8 md:pr-0 pl-8"
                    style="
                        background-image: url('/images/component-assets/radial-outline.png');
                        background-position: 43% 19%;
                        background-repeat: no-repeat;
                    "
                >
                    <div>
                        <p class="text-slate-800 text-2xl font-medium mb-1">
                            Looking for a specific hotel?
                        </p>
                        <p class="text-slate-500 text-sm font-normal mb-6">
                            Search for the exact hotel you want to stay at using
                            your award points.
                        </p>
                        <HotelDropdown
                            wrapperClasses="'h-10 bg-white rounded shadow border border-slate-200'"
                        />
                    </div>
                </div>
                <div
                    class="col-span-6 md:col-span-3 min-h-36 rounded-r overflow-hidden relative"
                    :style="`background-image: linear-gradient(
                                to right,
                                rgba(249, 250, 252, 1) 0%,
                                rgba(249, 250, 252, 1) 3%,
                                rgba(249, 250, 252, 0) 60%
                            ),
                            url('${property?.image_location}');
                        background-size: cover, cover;
                        background-position: center, center;
                        background-repeat: no-repeat, no-repeat`"
                >
                    <router-link
                        :to="`/hotels/properties/${property?.slug}`"
                        class="text-slate-500 text-xs font-medium px-2 py-1 bg-white/90 rounded absolute bottom-3 right-3 z-1 hover:bg-white"
                    >
                        {{ property?.name }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import HotelDropdown from '@/components/hotels/search/search-form/hotel-dropdown.vue';

const property = computed(() => {
    return properties.value[
        Math.floor(Math.random() * properties.value.length)
    ];
});

const properties = ref([]);

const getFeatured = () => {
    ApiService.apiCall('/hotels/featured', 'get').then((response) => {
        properties.value = response.data;
    });
};

onMounted(() => {
    getFeatured();
});
</script>
